module.exports = "/call-frontend/img/bg_welcome_dark.cf4b08db.png";